import i18n from "@/i18n";

const routes = {
  path: "/tournament",
  name: "Tournament",
  component: () =>
    import(/* webpackChunkName: "tournament" */ "@/views/tournament/Main"),
  children: [
    {
      path: "tournamentlist",
      alias: "",
      name: "TournamentList",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentList"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_list"),
        step: [
          i18n.t("menu.tournament.tournament"),
          // i18n.t("page.tournament.tournament_list"),
        ],
        menu_num: 5,
        sub_menu_num: 51,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentwrite",
      name: "Write",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_write"),
        step: [
          i18n.t("menu.tournament.tournament"),
          // i18n.t("page.tournament.tournament_write"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentwrite/:tournamentno+",
      name: "Modify",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentWrite"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_edit"),
        step: [
          i18n.t("menu.tournament.tournament"),
          // i18n.t("page.tournament.tournament_edit"),
        ],
        menu_num: 5,
        sub_menu_num: 52,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentview/:tournamentno",
      name: "TournamentCondition",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentView"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_view"),
        step: [
          i18n.t("menu.tournament.tournament"),
          // i18n.t("page.tournament.tournament_view"),
        ],
        menu_num: 5,
        sub_menu_num: 53,
        location: "/tournament/tournamentlist",
      },
    },
    {
      path: "tournamentrank/:tournamentno",
      name: "TournamentRank",
      component: () =>
        import(
          /* webpackChunkName: "tournament" */ "@/views/tournament/TournamentRank"
        ),
      prop: true,
      meta: {
        layout: "DefaultLayout",
        wrapId: "sub",
        subtitle: i18n.t("page.tournament.tournament_rank"),
        step: [
          i18n.t("menu.tournament.tournament"),
          // i18n.t("page.tournament.tournament_rank"),
        ],
        menu_num: 5,
        sub_menu_num: 53,
        location: "/tournament/tournamentlist",
      },
    },
  ],
};

export default routes;
